export default __webpack_public_path__ + "static/media/bg16.72cb67e3.jpg";